/**
 * The AI Roles Map quiz, reduced to one answer: which platform to start with.
 *
 * Each second-question answer (an intent id from client/src/lib/quizData.ts)
 * points at exactly one platform. That platform is what the result screen
 * leads with and what GoHighLevel is told, as the tag quizPlatformTag(name),
 * so each platform can get its own nurture sequence.
 *
 * Lives in shared/ because the server derives the platform from the intent id
 * itself rather than trusting a platform the browser names: the tag starts an
 * automation, and the client should not be able to pick which one.
 *
 * THE MAPPING IS A FIRST DRAFT FOR REVIEW. Two answers follow the owners'
 * Oct 26 2026 call, which split the nurture sequences as Claude for content,
 * ChatGPT for images, Perplexity for research: "write something" is Claude and
 * "make images" is ChatGPT. The rest take the highest-ranked general platform
 * in each intent's existing toolIds list, and intents with none (video
 * repurposing, app building, automation) point at Claude, the platform the
 * 12 Days of Claudmas teaches.
 * server/members.test.ts asserts every intent is mapped and every target is a
 * known platform, so a new quiz answer cannot ship without one.
 */

export const PLATFORMS = {
  claude: { name: "Claude", toolId: "claude" },
  chatgpt: { name: "ChatGPT", toolId: "chatgpt" },
  perplexity: { name: "Perplexity", toolId: "perplexity" },
  gemini: { name: "Gemini", toolId: "gemini" },
} as const;

export type PlatformKey = keyof typeof PLATFORMS;

export const INTENT_PLATFORM: Record<string, PlatformKey> = {
  "atlas-plan": "chatgpt",
  "atlas-documents": "claude",
  "atlas-research": "perplexity",
  "comet-summarize": "perplexity",
  "comet-compare": "perplexity",
  "comet-current": "perplexity",
  "comet-recall": "gemini",
  "manus-write": "claude",
  "manus-repurpose": "claude",
  "manus-visual": "chatgpt",
  "manus-slides": "claude",
  "manus-build-app": "claude",
  "manus-automate": "claude",
};

export function platformForIntent(intentId: string): PlatformKey | undefined {
  return INTENT_PLATFORM[intentId];
}
